type OptimisticUserMessage = {
  id: string;
  role: string;
  hubMessageId?: number;
  metadata?: Record<string, unknown>;
};

/**
 * The package creates an optimistic user row before the server can attach its
 * durable sender metadata. Stamp only that local row once the Core user id is
 * hydrated; persisted, unknown, and delegated rows retain their own metadata.
 */
export const getOptimisticCurrentUserMetadata = (
  messages: OptimisticUserMessage[],
  messageIdsBeforeSend: ReadonlySet<string>,
  currentUserId?: string | null,
): { id: string; metadata: Record<string, unknown> } | null => {
  if (!currentUserId) return null;

  const message = [...messages].reverse().find(
    (candidate) =>
      !messageIdsBeforeSend.has(candidate.id) &&
      candidate.role === "user" &&
      candidate.hubMessageId === undefined &&
      candidate.metadata?.sender_user_id === undefined,
  );
  if (!message) return null;

  return {
    id: message.id,
    metadata: {
      ...message.metadata,
      sender_user_id: currentUserId,
      message_origin: "user",
    },
  };
};
